import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";

import { RobotoButton } from "@/shared/components/RobotoButton";

interface UnsavedChangesDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onContinueNavigation: () => void;
}

export function UnsavedChangesDialog(props: UnsavedChangesDialogProps) {
  const { isOpen, onClose, onContinueNavigation } = props;

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disableRestoreFocus
    >
      <DialogTitle>Unsaved Changes</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          You have unsaved changes to your current layout. If you navigate away,
          these changes will be lost. Are you sure you want to continue?
        </Typography>
      </DialogContent>
      <DialogActions>
        <RobotoButton
          eventName="UnsavedChangesDialogCanceled"
          onClick={onClose}
        >
          Cancel
        </RobotoButton>
        <RobotoButton
          eventName="UnsavedChangesDialogContinued"
          onClick={onContinueNavigation}
          color="error"
          variant="contained"
        >
          Discard unsaved changes
        </RobotoButton>
      </DialogActions>
    </Dialog>
  );
}
